import {request} from '@/utils/request.js'

export function topSearchForBaiDu(data) {
    return request({
        url: '/topsearch/baidu',
        method: 'get',
        data: data
    })
}

export function topSearchForDouYin(data) {
    return request({
        url: '/topsearch/douyin',
        method: 'get',
        data: data
    })
}

export function topSearchForBilibili(data) {
    return request({
        url: '/topsearch/bilibili',
        method: 'get',
        data: data
    })
}

export function topSearchForWeiBo(data) {
    return request({
        url: '/topsearch/weibo',
        method: 'get',
        data: data
    })
}

export function topSearchForGitHubAllStars(data) {
    return request({
        url: '/topsearch/github/allstars',
        method: 'get',
        data: data
    })
}

export function topSearchForGitHubDaystars(data) {
    return request({
        url: '/topsearch/github/daystars',
        method: 'get',
        data: data
    })
}

export function topSearchForGitHubWeekstars(data) {
    return request({
        url: '/topsearch/github/weekstars',
        method: 'get',
        data: data
    })
}

export function topSearchForGitHubMonthstars(data) {
    return request({
        url: '/topsearch/github/monthstars',
        method: 'get',
        data: data
    })
}

export function topSearchForGitHubYearstars(data) {
    return request({
        url: '/topsearch/github/yearstars',
        method: 'get',
        data: data
    })
}

export function topSearchForGitHubThreeYearStars(data) {
    return request({
        url: '/topsearch/github/threeyearstars',
        method: 'get',
        data: data
    })
}

export function topSearchForGitHubFiveYearStars(data) {
    return request({
        url: '/topsearch/github/fiveyearstars',
        method: 'get',
        data: data
    })
}

export function topSearchForGitHubTenYearStars(data) {
    return request({
        url: '/topsearch/github/tenyearstars',
        method: 'get',
        data: data
    })
}

export function topSearchForYoutube(data) {
    return request({
        url: '/topsearch/global/youtube',
        method: 'get',
        data: data
    })
}

export function topSearchForDouBan(data) {
    return request({
        url: '/topsearch/douban',
        method: 'get',
        data: data
    })
}

export function topSearchForTencent(data) {
    return request({
        url: '/topsearch/tencent',
        method: 'get',
        data: data
    })
}

export function topSearchForTouTiao(data) {
    return request({
        url: '/topsearch/toutiao',
        method: 'get',
        data: data
    })
}

export function topSearchForWangYi(data) {
    return request({
        url: '/topsearch/wangyi',
        method: 'get',
        data: data
    })
}

export function topSearchForWangYiYunBiaoSheng(data) {
    return request({
        url: '/topsearch/biaoshengwangyiyun',
        method: 'get',
        data: data
    })
}

export function topSearchForWangYiYunXinGe(data) {
    return request({
        url: '/topsearch/xingegwangyiyun',
        method: 'get',
        data: data
    })
}

export function topSearchForWangYiYunYuanChuang(data) {
    return request({
        url: '/topsearch/yuanchuangwangyiyun',
        method: 'get',
        data: data
    })
}

export function topSearchForWangYiYunReGe(data) {
    return request({
        url: '/topsearch/regewangyiyun',
        method: 'get',
        data: data
    })
}

export function topSearchForBaiDuTieBa(data) {
    return request({
        url: '/topsearch/tiebabaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForShaoShuPai(data) {
    return request({
        url: '/topsearch/shaoshupai',
        method: 'get',
        data: data
    })
}

export function topSearchForDianShiJuBaiDu(data) {
    return request({
        url: '/topsearch/dianshijubaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForDianYingBaiDu(data) {
    return request({
        url: '/topsearch/dianyingbaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForXiaoShuoBaiDu(data) {
    return request({
        url: '/topsearch/xiaoshuobaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForYouXiBaiDu(data) {
    return request({
        url: '/topsearch/youxibaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForQiCheBaiDu(data) {
    return request({
        url: '/topsearch/qichebaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForReGengBaiDu(data) {
    return request({
        url: '/topsearch/regengbaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForCaiJingBaiDu(data) {
    return request({
        url: '/topsearch/caijingbaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForMinShengBaiDu(data) {
    return request({
        url: '/topsearch/minshengbaidu',
        method: 'get',
        data: data
    })
}

export function topSearchForHuggingFaceSpaceTrending(data) {
    return request({
        url: '/topsearch/global/huggingfacespacestrending',
        method: 'get',
        data: data
    })
}

export function topSearchForHuggingFaceSpaceLikes(data) {
    return request({
        url: '/topsearch/global/huggingfacespaceslikes',
        method: 'get',
        data: data
    })
}

export function topSearchForHuggingFaceModelTrending(data) {
    return request({
        url: '/topsearch/global/huggingfacemodelstrending',
        method: 'get',
        data: data
    })
}

export function topSearchForHuggingFaceModelLikes(data) {
    return request({
        url: '/topsearch/global/huggingfacemodellikes',
        method: 'get',
        data: data
    })
}

export function topSearchForHuggingFaceDatasetsTrending(data) {
    return request({
        url: '/topsearch/global/huggingfacedatasetstrending',
        method: 'get',
        data: data
    })
}

export function topSearchForHuggingFaceDatasetsLikes(data) {
    return request({
        url: '/topsearch/global/huggingfacedatasetslikes',
        method: 'get',
        data: data
    })
}

export function topSearchForZhiHu(data) {
    return request({
        url: '/topsearch/zhihu',
        method: 'get',
        data: data
    })
}

export function topSearchForDianShiJuTengXun(data) {
    return request({
        url: '/topsearch/dianshijutengxun',
        method: 'get',
        data: data
    })
}
export function topSearchForDianYingTengXun(data) {
    return request({
        url: '/topsearch/dianyingtengxun',
        method: 'get',
        data: data
    })
}
export function topSearchForDongManTengXun(data) {
    return request({
        url: '/topsearch/dongmantengxun',
        method: 'get',
        data: data
    })
}
export function topSearchForZongYiTengXun(data) {
    return request({
        url: '/topsearch/zongyitengxun',
        method: 'get',
        data: data
    })
}
export function topSearchForZongBangTengXun(data) {
    return request({
        url: '/topsearch/zongbangtengxun',
        method: 'get',
        data: data
    })
}


export function topSearchForDianShiJuAiQiYi(data) {
    return request({
        url: '/topsearch/dianshijuaiqiyi',
        method: 'get',
        data: data
    })
}
export function topSearchForDianYingAiQiYi(data) {
    return request({
        url: '/topsearch/dianyingaiqiyi',
        method: 'get',
        data: data
    })
}
export function topSearchForDongManAiQiYi(data) {
    return request({
        url: '/topsearch/dongmanaiqiyi',
        method: 'get',
        data: data
    })
}
export function topSearchForZongYiAiQiYi(data) {
    return request({
        url: '/topsearch/zongyiaiqiyi',
        method: 'get',
        data: data
    })
}
export function topSearchForZongBangAiQiYi(data) {
    return request({
        url: '/topsearch/zongbangaiqiyi',
        method: 'get',
        data: data
    })
}


export function topSearchForDianShiJuYouKu(data) {
    return request({
        url: '/topsearch/dianshijuyouku',
        method: 'get',
        data: data
    })
}
export function topSearchForDianYingYouKu(data) {
    return request({
        url: '/topsearch/dianyingyouku',
        method: 'get',
        data: data
    })
}
export function topSearchForDongManYouKu(data) {
    return request({
        url: '/topsearch/dongmanyouku',
        method: 'get',
        data: data
    })
}
export function topSearchForZongYiYouKu(data) {
    return request({
        url: '/topsearch/zongyiyouku',
        method: 'get',
        data: data
    })
}
export function topSearchForZongBangYouKu(data) {
    return request({
        url: '/topsearch/zongbangyouku',
        method: 'get',
        data: data
    })
}


export function topSearchForDianShiJuMangGuo(data) {
    return request({
        url: '/topsearch/dianshijumangguo',
        method: 'get',
        data: data
    })
}
export function topSearchForDianYingMangGuo(data) {
    return request({
        url: '/topsearch/dianyingmangguo',
        method: 'get',
        data: data
    })
}
export function topSearchForDongManMangGuo(data) {
    return request({
        url: '/topsearch/dongmanmangguo',
        method: 'get',
        data: data
    })
}
export function topSearchForZongYiMangGuo(data) {
    return request({
        url: '/topsearch/zongyimangguo',
        method: 'get',
        data: data
    })
}
export function topSearchForZongBangMangGuo(data) {
    return request({
        url: '/topsearch/zongbangmangguo',
        method: 'get',
        data: data
    })
}